<template>
    <div>
        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardHeader>
                        <strong>{{$t('defaultAccount')}}</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CRow>
                            <CCol col="3">
                                <CSelect
                                        :options="[{label:this.$t('select'),value:1},
                                        {label:this.$t('buy'),value:1},
                                        {label:this.$t('sidebars.addReturnBuyDocument'),value:2},
                  {label:this.$t('sell'),value:3},
                  {label:this.$t('returnSell'),value:4},
                   {label:this.$t('components.receive'),value:10},
                  {label:this.$t('chequeListDocsReceive'),value:20},
                  {label:this.$t('payOperation'),value:30},
                  {label:this.$t('components.cheques'),value:40},
                  {label:this.$t('sidebars.payroll'),value:50},]"
                                        :value.sync="selected_type"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol col="12">
                                {{$t('bedehkar')}}
                                <CDataTable
                                        :items="filtered_list_bed"
                                        :fields="fields"

                                        :items-per-page="20"
                                        hover
                                        border
                                        pagination
                                >
                                    <template #row="{item}">

                                        <td style="text-align: center">

                                        <p >{{ item.row_id + 1 }}</p>

                                        </td>

                                    </template>
                                    <template #titleFA="{item}">

                                        <td>
                                            <p >{{ item.titleFA }}</p>

                                        </td>

                                    </template>
                                    <template #value="{item,index}">

                                        <td>

                                            <treeselect
                                                    :options="items_accounting_list"
                                                    v-model="item.value"
                                                    appendToBody
                                                    :zIndex="2000"
                                                    @select="get_tafzili(item,index,1,...arguments)"
                                                    :async="false"
                                                    :placeholder="$t('dialogs.choose')"
                                            />
                                        </td>

                                    </template>
                                    <template #accountName="{item}">
                                        <td>
                                            <CSelect
                                                    :options="item.tafzili_list"
                                                    :value.sync="item.selected_tafzili"
                                            />
                                        </td>

                                    </template>

                                    <template #prefixOrLenght="{item}">

                                        <td>
                                            <CInput class="p-0 m-0" v-model="item.prefixOrLenght"></CInput>
                                        </td>

                                    </template>

                                    <template #operation="{item,index}">
                                        <td>

                                            <CIcon @click.native="insert_data(item)" class="text-dark"
                                                   name="saveNew"/>

                                        </td>
                                    </template>
                                    <template #operation2="{item,index}">
                                        <td>


                                        </td>
                                    </template>

                                </CDataTable>

                            </CCol>
                            <CCol col="12">
                                {{this.$t('bestankar')}}
                                <CDataTable
                                        :items="filtered_list_bes"
                                        :fields="fields"

                                        :items-per-page="20"
                                        hover
                                        border
                                        pagination
                                >
                                    <template #row="{item}">

                                        <td style="text-align: center">

                                        <p >{{ item.row_id + 1 }}</p>

                                        </td>

                                    </template>
                                    <template #titleFA="{item}">

                                        <td>
                                            <p >{{ item.titleFA }}</p>

                                        </td>

                                    </template>
                                    <template #value="{item,index}">

                                        <td>

                                            <treeselect
                                                    :options="items_accounting_list"
                                                    v-model="item.value"
                                                    appendToBody
                                                    :zIndex="2000"

                                                    @select="get_tafzili(item,index,2,...arguments)"
                                                    :async="false"
                                                    :placeholder="$t('dialogs.choose')"
                                            />
                                        </td>

                                    </template>
                                    <template #accountName="{item}">
                                        <td>
                                            <CSelect
                                                    :options="item.tafzili_list"
                                                    :value.sync="item.selected_tafzili"
                                            />
                                        </td>

                                    </template>

                                    <template #prefixOrLenght="{item}">

                                        <td>
                                            <CInput class="p-0 m-0" v-model="item.prefixOrLenght"></CInput>
                                        </td>

                                    </template>

                                    <template #operation="{item,index}">
                                        <td>

                                            <CIcon @click.native="insert_data(item)" class="text-dark"
                                                   name="saveNew"/>

                                        </td>
                                    </template>
                                    <template #operation2="{item,index}">
                                        <td>


                                        </td>
                                    </template>


                                </CDataTable>

                            </CCol>
                        </CRow>


                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    import Treeselect from '@riophae/vue-treeselect'

    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
    import BTabs from "../../tabs/BTabs";
    import Vue from 'vue'

    var items = [];


    export default {
        name: 'Login',
        components: {
            Treeselect,
        },
        data() {
            return {
                confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
                setting_key: '',
                setting_value: '',
                file: '',
                color: '#ffffff',
                previewImage: '',
                selected_type: 0,
                description: '',
                items_warehouse: [],
                items_product: [],
                items_accounting: [],

                fields: [
                    // {key: 'row', label: this.$t('tables.row'), _style: 'width:10%'},

                    {key: 'titleFA', label: this.$t('title'), _style: 'width:6%;'},
                    // {key: 'prefixOrLenght', label: "پیشوند", _style: 'width:10%'},

                    {key: 'value', label: this.$t('accountSarfasl'), _style: 'width:15%;'},
                    {key: 'accountName', label: this.$t('components.bankAccTitle'), _style: 'width:8%;'},
                    // {key: 'valueType', label: 'valueType', _style: 'width:20%;'},
                    // {key: 'module', label: 'module', _style: 'width:20%;'},
                    {key: 'operation', label: "", _style: 'width:2%;'},
                    {key: 'operation2', label: "", _style: 'width:15%;'},

                ],
                items_accounting_groups: [],
                items_accounting_list: [],
                items_accounting_sub_groups: [],
                role_checkbox_items: [],
                details: [],
                filtered_list_bed: [],
                filtered_list_bes: [],
                collapseDuration: 0,
                status_form: 0
            }
        },

        mounted() {
            this.$root.root_validate_errors = [];

            this.get_lists();
            this.get_lists_groups();
            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_item();

                } else {
                    this.status_form = 0;
                }
            });
        },
        watch: {
            'selected_type': function () {
                if (this.selected_type != 4 && this.selected_type != 2) {
                    this.filtered_list_bed = this.items_warehouse.filter(x => x.valueType == this.selected_type).filter(x => x.deptorCreditor == 1);
                    this.filtered_list_bes = this.items_warehouse.filter(x => x.valueType == this.selected_type).filter(x => x.deptorCreditor == 0);
                // console.log(this.filtered_list_bed)
                }
                if (this.selected_type == 2) {
                    this.filtered_list_bed = this.items_warehouse.filter(x => x.valueType == 2 || x.valueType == 1).filter(x => x.deptorCreditor == 1);
                    this.filtered_list_bes = this.items_warehouse.filter(x => x.valueType == 2 || x.valueType == 1).filter(x => x.deptorCreditor == 0);

                }
                if (this.selected_type == 4) {
                    this.filtered_list_bed = this.items_warehouse.filter(x => x.valueType == 4 || x.valueType == 3).filter(x => x.deptorCreditor == 1);
                    this.filtered_list_bes = this.items_warehouse.filter(x => x.valueType == 4 || x.valueType == 3).filter(x => x.deptorCreditor == 0);

                }
                this.filtered_list_bed.forEach(function (val) {
                    if(val.tafzili_list.length==1){
                        val.prefixOrLenght=val.tafzili_list[0].recId;
                        val.selected_tafzili=val.tafzili_list[0].recId;
                    }
                })
                this.filtered_list_bes.forEach(function (val) {
                    if(val.tafzili_list.length==1){
                        val.prefixOrLenght=val.tafzili_list[0].recId;
                        val.selected_tafzili=val.tafzili_list[0].recId;
                    }
                })

            }
        },
        computed: {},
        methods: {
            get_value_index(value, index) {
                console.log(JSON.parse(value.toString())[index])
                return JSON.parse(value.toString())[index];
                // return  JSON.parse(value)[index]
            },
            edit_item(item) {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                this.role_checkbox_items = [];

                this.status_form = this.items[item.row_id].id;
                this.get_role_info();
            }, emptyList() {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                this.name = '';
                this.role_checkbox_items = [];
                this.description = '';
                this.previewImage = '';
                this.status_form = 0;
            },
            get_lists() {
                var self = this;


                const formData = new FormData();

                // formData.append('id', this.selected_province);

                axios.post('GetSystemSettings', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        content_data.data.forEach((val) => {
                            if (val.valueType == 4) {
                                val.value = JSON.parse(val.value.toString())
                            }
                            if (val.module == 3) {
                                self.items_warehouse.push(val)
                            }

                            // if (val.module == 2) {
                            //   self.items_product.push(val)
                            // }
                            // if (val.module == 3) {
                            //   self.items_accounting.push(val)
                            // }
                            // if (val.module == 4) {
                            //   self.items_accounting_groups.push(val)
                            // }

                        });
                        for (var i = 0; i < self.items_warehouse.length; i++) {
                            if (self.items_warehouse[i].value) {
                                self.get_tafzili2(self.items_warehouse[i], i);

                            }

                        }
                        self.items_warehouse.forEach((val) => {

                        })
                        self.items = content_data.data.map((item, row_id) => {
                            return {...item, row_id}
                        });
                    } else {
                        self.$root.modal_component.show_api_response_modals(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            insert_data(item) {

                // if (!this.validateForm()) {
                //   console.log("validate form is false" + this.validate_errors);
                //   return true;
                // }
                let self = this;
                // var grp_info = {groupName:self.name};
                // var operation_systems = new Array();
//grp_info.groupName = self.name;

                const formData = new FormData();
                let url;
                if (this.status_form == 0) {
                    url = "UpdateSystemSetting";
                } else {
                    url = "UpdateSystemSetting";

                }
                // var person = new Object();
                // person.groupName = self.name;
                formData.append('id', item.id)

                // console.log("json group"+ JSON.stringify(person));
                formData.append('Value', item.value);
                formData.append('prefixOrLenght', item.selected_tafzili);
                // formData.append('OperationSystems',  OperationSystems);
                axios.post(url, formData, {}).then((res) => {

                    self.$root.modal_component.show_api_response_modals(res)

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_lists_groups() {
                var self = this;
                self.items_accounting_list = [];

                const formData = new FormData();
                var url = "Get_AllAccountingGroups";

                // formData.append("id", 1);

                axios.post(url, formData, {}).then(function (response) {

                        var content_data = response.data;

                        if (content_data.statusCode == 0) {


                            response.data.data.forEach((val) => {
                                if (val.parentId == 0) {

                                    var obj = {
                                        label: val.accountName + " (" + val.accountCode + ")",
                                        name_code: val.accountName + " (" + val.accountCode + ")",
                                        nature: val.nature,
                                        type: val.type,
                                        code: val.accountCode,
                                        id: val.id,
                                        children: self.get_childrens(val.id, response.data.data)
                                    }
                                    self.items_accounting_list.push(obj);
                                }

                            });

                        } else {
                            self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                        }

                    }
                )
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            get_childrens(parent_id, list) {
                var array = [];
                var self = this;
                list.forEach((val2) => {

                    if (parent_id == val2.parentId) {
                        var obj = {
                            label: val2.accountName+ " (" + val2.accountCode + ")",
                            name_code: val2.accountName + " (" + val2.accountCode + ")",
                            code: val2.accountCode, id: val2.id, nature: val2.nature,
                            type: val2.type,

                        }
                        if (self.get_childrens(val2.id, list) != null) {
                            obj.children = this.get_childrens(val2.id, list)
                        }
                        array.push(obj);
                        // val2.inserted = true;

                    }
                });
                if (array.length) {
                    return array;

                } else {
                    return null;

                }
            },

            get_tafzili(item, index, type, node) {
                var self = this;
                const formData = new FormData();
                var url = "GetAccountTafsiliList";
                formData.append("id", node.id);


                axios.post(url, formData, {}).then(function (response) {

                        var content_data = response.data;

                        if (content_data.statusCode == 0) {


                            var sorted = [];
                            var selected_tafzili = 0;
                            if (response.data.data.length) {
                                sorted = self.sort_array(
                                    [], response.data.data,
                                    'recId', 'title');
                                selected_tafzili = sorted[0].value

                            }
                            // item.tafzili_list = sorted;
                            // item.selected_tafzili = selected_tafzili;
                            // Vue.set(self.items_warehouse,index,item);

                            if (type == 1) {
                                Vue.set(self.filtered_list_bed[index], 'tafzili_list', sorted);
                                Vue.set(self.filtered_list_bed[index], 'selected_tafzili', selected_tafzili);

                            } else {
                                Vue.set(self.filtered_list_bes[index], 'tafzili_list', sorted);
                                Vue.set(self.filtered_list_bes[index], 'selected_tafzili', selected_tafzili);

                            }
                        } else {
                            self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                        }

                    }
                )
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            get_tafzili2(item, index) {
                var self = this;
                const formData = new FormData();
                var url = "GetAccountTafsiliList";
                formData.append("id", item.value);


                axios.post(url, formData, {}).then(function (response) {

                        var content_data = response.data;

                        if (content_data.statusCode == 0) {

                            var sorted = [];
                            if (response.data.data.length) {
                                sorted = self.sort_array(
                                    [], response.data.data,
                                    'recId', 'title');
                            }
                            // item.tafzili_list = sorted;
                            // item.selected_tafzili = selected_tafzili;
                            // Vue.set(self.items_warehouse,index,item);

                            Vue.set(self.items_warehouse[index], 'tafzili_list', sorted);
                            Vue.set(self.items_warehouse[index], 'selected_tafzili', parseInt(item.prefixOrLenght));


                        } else {
                            // self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                        }

                    }
                )
                    .catch(function (error) {
                        console.log(error);
                    });

            },

            delete_item_dialog(item) {
                this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

                this.status_form = item.id;

            },
            delete_item() {


                let self = this;
                const formData = new FormData()
                let url;
                url = "DeleteSetting";


                formData.append('Id', this.status_form);

                axios.post(url, formData, {}).then((res) => {
                    self.$root.modal_component.show_api_response_modals(res);

                    self.status_form = 0;

                    self.get_lists();


                })
                    .catch(function (error) {

                        console.log(error);
                    });
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },
        }
    }

</script>
